import template from './patientConnection.html';
import './patientConnection.less';

class PatientConnectionController {
    constructor(PatientConnectionService, AppUserService, $state) {
        'ngInject';
        this.PatientConnectionService = PatientConnectionService;
        this.AppUserService = AppUserService;
        this.$state = $state;
    }

    $onInit() {
        this.isNewUser = this.AppUserService.isNewUser();
        this.verifyError = '';

        this.profiles = [];
        this.patient = {};
        this.careTeam = { contact: {} };

        this.schedule = {};

        this.connModel = {
            connectionStatus: 'pending',
            connectionUser: {},
            verifyFields: []
        };
        this.getPatientConnection(this.emailToken);
    }

    $onChanges(changes) {
        if (changes.emailToken && !changes.emailToken.isFirstChange()) {
            this.getPatientConnection(changes.emailToken);
        }
    }

    getPatientConnection(emailToken) {
        this.isLoadingConnection = true;
        return this.PatientConnectionService.getPatientConnection(emailToken)
            .then((model) => {
                this.loadModel(model);
                this.isLoadingConnection = false;
            });
    }

    loadModel(connectionModel) {
        this.profiles = connectionModel.profiles;
        this.patient = connectionModel.patient;
        this.careTeam = connectionModel.careTeam;

        this.connModel = connectionModel.patientConnection;

        this.schedule = connectionModel.schedule;

        // set expired to true when schedule is expired
        this.expired = this.schedule && this.schedule.expiredAt && new Date(this.schedule.expiredAt) < new Date();

        if (this.connModel.connectionStatus === 'active') {
            this.$state.go('pages.dashboard', { expired: this.expired, isFromPatientConnect: true, preselectedPatient: connectionModel.patient }, {})
        }
    }

    isConnectionCompleted() {
        let connectionStatus = this.connModel && this.connModel.connectionStatus;
        return ['declined', 'cancelled', 'expired'].indexOf(connectionStatus) > -1;
    }

    handleVerifyForm(event) {
        let { verifyFields, confirmUser } = event;

        let promise;
        promise = this.PatientConnectionService.verifyPatientConnection(this.emailToken, verifyFields, confirmUser);
        promise
            .then((model) => {
                this.loadModel(model);
                this.verifyError = '';
            })
            .catch((err) => {
                console.log(err)
                this.verifyError = err;
            });
    }

    handleAddAsNewProfile() {
        this.PatientConnectionService.addAsNewProfile(this.emailToken)
            .then((model) => {
                this.loadModel(model);
            });
    }

    handleMergeProfile(event) {
        let profile = event.profile;
        this.PatientConnectionService.mergeToProfile(this.emailToken, profile)
            .then((model) => {
                this.loadModel(model);
            });
    }

    handleCancelShare() {
        this.PatientConnectionService.cancelShare(this.emailToken)
            .then((model) => {
                this.loadModel(model);
            });
    }

}

export const PatientConnectionComponent = {
    name: 'mmsPatientConnection',
    component: {
        template: template,
        controller: PatientConnectionController,
        bindings: {
            emailToken: '<',
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/patientConnection/patientConnection.component.js